import React from 'react';
import { createMuiTheme, responsiveFontSizes } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import blue from '@material-ui/core/colors/blue';
import deepOrange from '@material-ui/core/colors/deepOrange';
import { CssBaseline } from '@material-ui/core';
import { useAppContext } from 'hooks/useAppContext';
import AppConfig from 'classes/AppConfig';

const makeTheme = (type) => createMuiTheme({
  root: {
    borderRadius: 0
  },
  palette: {
    type: type,
    primary: AppConfig.isProd ? { light: blue[700], main: blue[800], dark: blue[900] } : { light: deepOrange[700], main: deepOrange[800], dark: deepOrange[900] },
    secondary: {
      main: '#ffd740',
    },
    fab: "#FF5252"
  },
  drawer: {
    width: 210
  },
  hidden: {
    display: "none"
  },
  visible: {
    display: "flex"
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(',')
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '*': {
          'scrollbar-width': 'thin',
        },
        '*::-webkit-scrollbar': {
          width: '8px',
          height: '4px',
        },
        '*::-webkit-scrollbar-track': {
          '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)'
        },
        '*::-webkit-scrollbar-thumb': {
          backgroundColor: '#708090c4',
          borderRadius: "48px"
        }
      }
    }
  }
});


let LightTheme = makeTheme('light');
LightTheme = responsiveFontSizes(LightTheme);

let DarkTheme = makeTheme('dark');
DarkTheme = responsiveFontSizes(DarkTheme);

const ApplicationThemeProvider = ({ children }) => {

  const { themePaletteType } = useAppContext();

  return (
    <ThemeProvider theme={themePaletteType === 'light' ? LightTheme : DarkTheme}>
      <CssBaseline>
        {children}
      </CssBaseline>
    </ThemeProvider>
  )
}

export default ApplicationThemeProvider;